import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../../feature.types";
import { buildCrudPermissions, permissionId } from "../../../shared/featureFactories";

function buildViewOnlyPermissions(action: string) {
  return { view: action, create: action, edit: action, delete: action };
}

export const DaybookFeature: FeatureMetadata = {
  id: "accounts-daybook",
  moduleName: "feesFinance",
  navigation: {
    label: "Daybook",
    path: "/accounts/daybook",
    icon: ClipboardDocumentListIcon,
    order: 3,
    parentId: "accounts",
  },
  route: {
    path: "/accounts/daybook",
    element: lazy(() => import("./pages/DaybookPage")),
  },
  permissions: buildCrudPermissions(
    "FeeFinance",
    "Accounts",
    buildViewOnlyPermissions(permissionId("FeeFinance", "Accounts", "daybook")),
  ),
  readiness: "live",
};
